(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-vivo-inline-filter-toggle]');
    if (!(trigger instanceof HTMLButtonElement)) return;
    trigger.setAttribute('aria-expanded', String(trigger.getAttribute('aria-expanded') !== 'true'));
  });
  } catch(e) { console.error(e); }
})();

})();
